import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { OnboardCard } from '../../onboard-card';
import { useHomePageOnboardContext } from '../../../../home-page-onboard-context';
import { OrderImportCardFooter } from './order-import-card-footer';
import { OrderImportCardBody } from './order-import-card-body';
import stores from './stores.svg';
import DataDrivenLogo from '../../../../../../components/data-driven-logo';

import { ConnectedItem } from '../../connected-item';
import style from '../../onboard-cards.module.less';
import { messages } from '../../messages';
import { ManualOrderHeaderImage } from './manual-order-header-image';

export const OrderImportCard = () => {
  const intl = useIntl();
  const { isOrderImportComplete, hasConnectedStore } = useHomePageOnboardContext();
  const completeTitle = hasConnectedStore ? messages.connectedStoreTitle : messages.orderImportCardTitleCompleteOrders;
  const title = isOrderImportComplete ? completeTitle : messages.orderImportCardTitleIncomplete;
  const { sellerStoreToRender } = useHomePageOnboardContext();
  const storeName = hasConnectedStore ? sellerStoreToRender.name : null;
  const headerImage = useMemo(() => {
    if (hasConnectedStore) {
      return (
        <ConnectedItem
          connectedIcon={<DataDrivenLogo className={style['marketplace-icon']} marketplaceId={sellerStoreToRender.marketplaceId} />}
        />
      );
    }
    if (isOrderImportComplete && !hasConnectedStore) {
      return <ManualOrderHeaderImage />;
    }
    return <img alt={intl.formatMessage(messages.orderImportAltText)} src={stores} />;
  }, [hasConnectedStore, intl, isOrderImportComplete, sellerStoreToRender.marketplaceId]);
  return (
    <>
      <OnboardCard headerImage={headerImage} isComplete={isOrderImportComplete} store={storeName} title={title}>
        <OrderImportCardBody />
        <OrderImportCardFooter />
      </OnboardCard>
    </>
  );
};
